import TrainingPreferences from "@/components/Onboarding/TrainingPreferences/TrainingPreferences";

function TrainingPreferencesPage() {
  return <TrainingPreferences />;
}

export default TrainingPreferencesPage;
